import React from "react"
import { navigate } from "gatsby"
import Form from "./Form"
import { handleLogin, isLoggedIn } from "../utils/auth"
import {noScroll} from "../utils/utils"

class LoginPage extends React.Component {
  state = {
    username: ``,
    password: ``
   
  }

  componentDidMount(){
    noScroll();
  }

  handleUpdate(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    handleLogin(this.state)
  }

  render() {
    if (isLoggedIn()) {
      navigate(`/portfolio`)

    }

    return (
        
        <Form ref = {form => {this.form = form;}}
          handleUpdate={e => this.handleUpdate(e)}
          handleSubmit={e => this.handleSubmit(e)}
          
        />
      
    )
  }
}

export default LoginPage
